/* Store-wide cart drawer: Arabic labels on every page (the drawer strings come from the English locale). */
(function () {
  var labels = {
    'Your cart': 'سلة التسوق',
    'Your cart is empty': 'سلتك فارغة',
    'Continue shopping': 'متابعة التسوق',
    'Savings': 'التوفير',
    'Subtotal': 'المجموع الفرعي',
    'Total': 'الإجمالي',
    'Check out': 'إتمام الطلب',
    'Checkout': 'إتمام الطلب',
    'Cart reserved for': 'الوقت المتبقي للسلة',
    'Regular price': 'السعر الأصلي',
    'Sale price': 'السعر الحالي',
    'Loading...': 'جارٍ التحديث…'
  };

  function ltr(text) {
    var b = document.createElement('bdi');
    b.dir = 'ltr';
    b.textContent = text;
    return b;
  }

  function localize(drawer) {
    drawer.lang = 'ar';
    drawer.dir = 'rtl';
    var heading = drawer.querySelector('.drawer__heading');
    var count = heading && heading.textContent.trim().match(/^Cart\s*[•·]\s*(\d+)\s*items?$/i);
    if (count) heading.replaceChildren(document.createTextNode('سلة التسوق · '), ltr(count[1]));

    var walker = document.createTreeWalker(drawer, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.parentElement.closest('script, style, noscript')) continue;
      var text = node.nodeValue.trim();
      if (!text) continue;
      if (labels[text]) node.nodeValue = node.nodeValue.replace(text, labels[text]);
      else if (/^Cart reserved for/.test(text)) node.nodeValue = node.nodeValue.replace('Cart reserved for', 'الوقت المتبقي للسلة');
    }
    drawer.querySelectorAll('.cart-drawer-item__saving').forEach(function (el) {
      var match = el.textContent.trim().match(/^\(?You save (.+?)\)?$/);
      if (match) el.replaceChildren(document.createTextNode('وفّرت '), ltr(match[1]));
    });
    drawer.querySelectorAll('[aria-label]').forEach(function (el) {
      var label = el.getAttribute('aria-label');
      if (label === 'Close') el.setAttribute('aria-label', 'إغلاق السلة');
      else if (labels[label]) el.setAttribute('aria-label', labels[label]);
      else if (/^Remove /.test(label)) el.setAttribute('aria-label', label.replace('Remove ', 'إزالة '));
    });
  }

  // ===== Cart upsell (one box for the whole store) =====
  // With exactly one piece of these products in the cart, offer more: a second piece in any colour, or
  // (with `addons`) the product's add-on variants; no offer once an add-on is already in the cart.
  // Every option is a compact row with its photo, what it adds, the price and a quantity stepper. The box
  // keeps one fixed layout whatever is picked. The saving shown is the real one: compare-at price minus price
  // (there is no extra bundle discount).
  var ASSETS = (function () {
    var s = document.currentScript && document.currentScript.src;
    return s ? s.replace(/[^/]*$/, '') : '';
  })();
  var UPSELL = {
    'ronoo-ai': {
      bundle: 'قطعتان',
      title: 'أضف رونوو ثانيًا للطلب', text: 'لطفلين في البيت، أو هدية جاهزة مع واحد لك.',
      card: 'بلون ثانٍ وبنفس المميزات'
    },
    'بيبي-ليدودوو-baby-ledodoo': {
      bundle: 'دميتان',
      title: 'أضف دمية ثانية للطلب', text: 'لطفلين في البيت، أو هدية جاهزة مع واحدة لك.',
      card: 'بلون ثانٍ وبنفس المميزات'
    },
    'روبوت-إيليكو-eiliko': {
      title: 'أعطِ إيليكو شخصيات جديدة',
      text: 'كل زي يغيّر تعابير إيليكو وحركاته.',
      count: [49202725716120, 49202725748888],
      addons: {
        67595888230552: { name: 'Spin Kit 1', pitch: 'كاوبوي، طفل، دراكولا، هاواي', img: 'eiliko-upsell-kit1.webp' },
        67595888263320: { name: 'Spin Kit 2', pitch: 'ساحر، تشان، ديناصور، نحلة', img: 'eiliko-upsell-kit2.webp' },
        67595888296088: { name: 'Mystery Box', pitch: 'قطع مفاجئة من الطقمين' }
      }
    }
  };
  var COLORS = { panda: 'باندا', brown: 'بني', pink: 'وردي', yellow: 'أصفر', purple: 'بنفسجي', blue: 'أزرق', 'tiger pink': 'وردي نمري' };
  var products = {};
  var upsellTimer = 0;

  function root() { return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/'; }
  // Isolated left-to-right, so '349 QAR' keeps its order inside Arabic sentences.
  function money(cents) { return '⁦' + (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 2 }) + ' QAR⁩'; }
  function colorName(v) { return COLORS[String(v.title).toLowerCase()] || v.title; }
  function sized(src, w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function productJson(handle) {
    if (!products[handle]) products[handle] = fetch(root() + 'products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.json(); });
    return products[handle];
  }

  function renderUpsell(drawer) {
    fetch(root() + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var wanted = {};
      (cart.items || []).forEach(function (item, i) {
        var cfg = UPSELL[item.handle];
        if (!cfg) return;
        var w = wanted[item.handle] || (wanted[item.handle] = { qty: 0, line: null, index: -1 });
        if (cfg.addons && cfg.addons[item.variant_id]) { w.taken = true; return; }
        if (cfg.count && cfg.count.indexOf(item.variant_id) < 0) return;
        if (!w.line) { w.line = item; w.index = i; }
        w.qty += item.quantity;
      });
      Object.keys(wanted).forEach(function (handle) { if (wanted[handle].taken) wanted[handle].qty = 0; });
      // Drop offers that no longer apply.
      drawer.querySelectorAll('[data-iq-upsell]').forEach(function (node) {
        var w = wanted[node.dataset.iqUpsell];
        if (!w || w.qty !== 1 || !w.line || node.dataset.key !== w.line.key) node.remove();
      });
      Object.keys(wanted).forEach(function (handle) {
        var w = wanted[handle];
        if (w.qty !== 1) return;
        var row = drawer.querySelector('#CartDrawer-Item-' + (w.index + 1));
        if (!row || drawer.querySelector('[data-iq-upsell="' + handle + '"]')) return;
        productJson(handle).then(function (product) { build(drawer, row, handle, product, w.line); });
      });
    }).catch(function () {});
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function build(drawer, row, handle, product, line) {
    if (!row.isConnected || drawer.querySelector('[data-iq-upsell="' + handle + '"]')) return;
    var cfg = UPSELL[handle];
    var addons = cfg.addons;
    var options = product.variants.filter(function (v) { return v.available && (!addons || addons[v.id]); });
    if (!options.length) return;
    // A second piece leads with a colour the customer doesn't have yet.
    if (!addons) options.sort(function (a, b) { return (a.id === line.variant_id) - (b.id === line.variant_id); });
    var label = function (v) { return addons ? addons[v.id].name : colorName(v); };
    var own = function (v) { return !!(addons && addons[v.id].img); };
    var photo = function (v) {
      if (own(v)) return ASSETS + addons[v.id].img;
      var src = (v.featured_image && v.featured_image.src) || product.featured_image || '';
      return src.indexOf('//') === 0 ? 'https:' + src : src;
    };
    var qty = {};
    options.forEach(function (v, i) { qty[v.id] = i === 0 ? 1 : 0; });

    var node = document.createElement(row.tagName === 'TR' ? 'tr' : 'li');
    var box = row.tagName === 'TR' ? node.appendChild(document.createElement('td')) : node;
    if (row.tagName === 'TR') box.colSpan = 99;
    node.dataset.iqUpsell = handle;
    node.dataset.key = line.key;
    box.className = 'iq-upsell';
    box.dir = 'rtl';

    var head = box.appendChild(el('div', 'iq-upsell__head'));
    head.appendChild(el('p', 'iq-upsell__title', cfg.title));
    head.appendChild(el('p', 'iq-upsell__text', cfg.text));
    var list = box.appendChild(el('div', 'iq-upsell__list'));
    list.setAttribute('role', 'group');
    list.setAttribute('aria-label', cfg.title);

    // One compact row per option: photo, name with what it adds, price, and a small stepper.
    var counters = {};
    options.forEach(function (v) {
      var info = addons ? addons[v.id] : {};
      var card = list.appendChild(el('div', 'iq-upsell__row'));
      var img = card.appendChild(el('img', 'iq-upsell__thumb' + (own(v) ? '' : ' is-product')));
      img.src = own(v) ? photo(v) : sized(photo(v), 160);
      img.alt = label(v);
      img.width = 58;
      img.height = 58;
      img.loading = 'lazy';
      var body = card.appendChild(el('div', 'iq-upsell__info'));
      var name = body.appendChild(el('b', 'iq-upsell__name'));
      name.appendChild(el('bdi', '', label(v)));
      body.appendChild(el('span', 'iq-upsell__pitch', addons ? info.pitch : cfg.card));
      var price = body.appendChild(el('span', 'iq-upsell__price'));
      price.appendChild(el('b', '', money(v.price)));
      // The old price shows the number only; the currency is already on the price beside it.
      if (v.compare_at_price > v.price) price.appendChild(el('s', '', String(v.compare_at_price / 100)));
      var step = card.appendChild(el('div', 'iq-upsell__step'));
      var minus = step.appendChild(el('button', '', '−'));
      var count = step.appendChild(el('output', '', String(qty[v.id])));
      var plus = step.appendChild(el('button', '', '+'));
      minus.type = plus.type = 'button';
      minus.setAttribute('aria-label', 'تقليل ' + label(v));
      plus.setAttribute('aria-label', 'زيادة ' + label(v));
      counters[v.id] = { card: card, count: count, minus: minus };
      minus.addEventListener('click', function () { qty[v.id] = Math.max(0, qty[v.id] - 1); paint(); });
      plus.addEventListener('click', function () { qty[v.id] = Math.min(9, qty[v.id] + 1); paint(); });
    });

    var add = box.appendChild(el('button', 'iq-upsell__add'));
    add.type = 'button';
    var addText = add.appendChild(el('span', 'iq-upsell__add-text'));
    var addTotal = add.appendChild(el('span', 'iq-upsell__add-total'));
    var error = box.appendChild(el('p', 'iq-upsell__error'));
    error.setAttribute('role', 'alert');
    error.hidden = true;

    function paint() {
      var pieces = 0, total = 0;
      options.forEach(function (v) {
        var c = counters[v.id];
        c.count.textContent = String(qty[v.id]);
        c.minus.disabled = qty[v.id] < 1;
        c.card.classList.toggle('is-on', qty[v.id] > 0);
        pieces += qty[v.id];
        total += qty[v.id] * v.price;
      });
      add.disabled = pieces < 1;
      addText.textContent = pieces ? 'أضف ' + pieces + ' إلى السلة' : 'اختر الكمية من الأعلى';
      addTotal.textContent = pieces ? money(total) : '';
    }
    paint();

    add.addEventListener('click', function () {
      var p = line.properties || {};
      var items = options.filter(function (v) { return qty[v.id] > 0; }).map(function (v) {
        var props = { '_Color Label': label(v), '_Compare Price': String(v.compare_at_price || v.price), '_Custom Image': photo(v) };
        if (p['_Bundle Key'] && !addons) { props['_Bundle Key'] = p['_Bundle Key']; props['_Bundle Title'] = cfg.bundle; }
        return { id: v.id, quantity: qty[v.id], properties: props };
      });
      if (!items.length) return;
      add.disabled = true;
      error.hidden = true;
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
      }).then(function (r) {
        return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || data.message || ''); return data; });
      }).then(function (data) {
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.renderContents === 'function') d.renderContents(data); else location.reload();
      }).catch(function (ex) {
        add.disabled = false;
        error.textContent = ex.message || 'تعذّرت الإضافة، حاول مرة أخرى.';
        error.hidden = false;
      });
    });
    row.after(node);
  }

  function boot() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.iqCart) return;
    drawer.dataset.iqCart = '1';
    var busy = false;
    function run(mutations) {
      // Our own upsell box changing is not a cart change.
      var cartChanged = !mutations || mutations.some(function (m) { return !(m.target.closest && m.target.closest('[data-iq-upsell]')); });
      if (cartChanged) { clearTimeout(upsellTimer); upsellTimer = setTimeout(function () { renderUpsell(drawer); }, 250); }
      if (busy) return;
      busy = true;
      localize(drawer);
      // Our own text edits trigger the observer once more; let that pass settle before listening again.
      requestAnimationFrame(function () { busy = false; });
    }
    new MutationObserver(run).observe(drawer, { childList: true, subtree: true, characterData: true });
    run();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
